import React from "react";
import "../mycontent.css";
import { Form, Input, Button, Card, DatePicker } from "antd";
import { connect } from "react-redux";
import {
  fetchProfessor,
  createProfessor,
  updateProfessor,
  emptyProfessor,
} from "../../../../store/actions/selfProfessorAction";
import {
  // CONTENT_CREATOR_BASE_URL,
  // defaultRoundsList,
  MY_CONTENT_BASE_URL,
  // STUDENT_CONTENT_BASE_URL,
} from "../../../../constants/LookupConst";
import CircularProgress from "../../../../components/CircularProgress";
import { toast } from "react-toastify";
import moment from "moment";
// const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

class SelfProfessor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  formRef = React.createRef();

  async componentDidMount() {
    const {
      match: { params },
      fetchProfessor,
    } = this.props;
    if (params.id) {
      await fetchProfessor(params.id);
    }
  }

  async componentWillUnmount() {
    this.props.emptyProfessor();
  }

  render() {
    const onFinish = async (values) => {
      const { history } = this.props;
      if (!params.id) {
        await this.props.createProfessor(values, (res) => {
          if (res.success) {
            toast.success(res.message);
          } else {
            toast.error(res.message);
          }
        });
      } else {
        await this.props.updateProfessor(values, params.id, (res) => {
          if (res.success) {
            toast.success(res.message);
          } else {
            toast.error(res.message);
          }
        });
      }
      history.push(`${MY_CONTENT_BASE_URL}?tab=professor`);
    };

    const {
      // lookupProfessorYears,
      // location: { search },
      match: { params },
      selectedProfessor,
      loading,
      // countries,
      // professors,
    } = this.props;
    const data = selectedProfessor;
    if (!(data && data._id) && params.id) {
      return (
        <div className="gx-loader-view">
          <CircularProgress />
        </div>
      );
    }
    return (
      <Card className="gx-card blast-mc" title="Create Professor">
        {!loading ? (
          <Form
            ref={this.formRef}
            {...formItemLayout}
            name="register"
            onFinish={onFinish}
            scrollToFirstError
          >
            <Form.Item
              name="name"
              label="Name"
              initialValue={data.name}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid name",
                },
                {
                  required: true,
                  message: "Please input name",
                },
              ]}
            >
              <Input placeholder="Please enter a name" value={data.name} />
            </Form.Item>
            <Form.Item
              name="startdate"
              label="Start date"
              // rules={[
              //   {
              //     required: true,
              //     message: "Please select test date!",
              //   },
              // ]}
              initialValue={moment()}
            >
              <DatePicker
                placeholder="Please enter a start date"
                // value={scheduledAt}
                format="MM/DD/YYYY"
                className="gx-w-100"
                // onChange={this.onDateChange}
              />
            </Form.Item>
            <Form.Item
              name="enddate"
              label="End date"
              // rules={[
              //   {
              //     required: true,
              //     message: "Please select test date!",
              //   },
              // ]}
              // initialValue={moment()}
            >
              <DatePicker
                placeholder="Please enter a end date"
                // value={scheduledAt}
                format="MM/DD/YYYY"
                className="gx-w-100"
                // onChange={this.onDateChange}
              />
            </Form.Item>
            <Form.Item
              name="additionalinformation"
              label="Additional Information"
              initialValue={data.additionalinformation}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid additionalinformation",
                },
                // {
                //   required: true,
                //   message: "Please input additionalinformation",
                // },
              ]}
            >
              <Input
                placeholder="Please enter a additionalinformation"
                value={data.additionalinformation}
              />
            </Form.Item>
            <Form.Item {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit">
                {!!params.id ? "Update" : "Create"}
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <div className="gx-loader-view">
            <CircularProgress />
          </div>
        )}
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedProfessor: state.selfprofessors.selectedProfessor,
  loading: state.selfprofessors.loading,
});

const mapDispatchToProps = {
  createProfessor,
  fetchProfessor,
  updateProfessor,
  emptyProfessor,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelfProfessor);
